exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Homepage{text-align:center;color:#fff}.Homepage h1{font-size:24px;font-weight:100;color:#fff}.Homepage h1 em{font-size:48px;font-weight:700;display:block;font-style:normal;position:relative}.Homepage h1 em:before{position:absolute;content:\"\";background-image:url(" + require("../../../icons/getting-started/sql-clone-logo.png") + ");background-repeat:no-repeat;width:38px;height:53px;display:block;left:50%;transform:translateX(-50%);margin-left:-160px;margin-top:-5px}.Homepage p{max-width:550px;text-align:left;margin:7rem auto 2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/home/IntroPage/index.scss
// module id = 1030
// module chunks = 0